import openaiLogo from '../../assets/icons/openai-logo.svg';
import anthropicLogo from '../../assets/icons/anthropic-logo.svg';
import geminiLogo from '../../assets/icons/gemini-logo.svg';

const ColoredCircle = ({ color }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" className="mt-1 flex-shrink-0">
    <circle cx="8" cy="8" r="6" fill="currentColor" className={color} />
  </svg>
);

const About = () => {
  const qualityScores = [
    { score: '91-100', label: 'Publish-Ready', color: 'text-green-500', description: 'Ready for use with minimal or no edits.' },
    { score: '70-90', label: 'Flawed', color: 'text-orange-500', description: 'Understandable but contains noticeable issues. Requires human review and correction. Use with caution.' },
    { score: '1-69', label: 'Unusable', color: 'text-red-500', description: 'Difficult to understand or use reliably. Re-generate or assign for full human translation.' },
  ];

  return (
    <div className="w-full bg-gray-50">
      <div className="max-w-[1400px] mx-auto py-8 px-4 md:py-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 md:gap-6">
          <div>
            <h3 className="text-lg font-semibold pt-0 pb-4 md:pb-4">How it Works</h3>
            <div className="pb-6 space-y-4">
              <p className="text-sm text-[#6B7280]">
                We utilize Large Language Models (LLMs) to evaluate translation quality and provide improvement suggestions. Our evaluation method is inspired by the <a className="text-[#3B82F6] hover:text-blue-800 mt-2" href="https://arxiv.org/pdf/2310.13988" target="_blank" rel="noopener noreferrer">GEMBA-MQM</a> framework, where the LLM identifies specific error types (accuracy, fluency, etc.) and assesses their severity to generate a detailed quality score and actionable feedback.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold pt-0 pb-4">Scoring System</h3>
            <div className="pb-6">
              <div className="space-y-4">
                {qualityScores.map(({ score, label, color, description }) => (
                  <div key={score} className="flex items-start space-x-3">
                    <ColoredCircle color={color} />
                    <div className="flex-1">
                      <div className="font-medium">
                        {score} — {label}
                      </div>
                      <p className="text-sm text-[#6B7280]">{description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold pt-0 pb-4">Supported LLMs</h3>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <img src={openaiLogo} alt="OpenAI" className="h-6 w-6" />
                <span className="text-sm">OpenAI (GPT-5, GPT-5-mini, GPT-4.1, GPT-o3)</span>
              </div>
              <div className="flex items-center space-x-2">
                <img src={anthropicLogo} alt="Anthropic" className="h-6 w-6" />
                <span className="text-sm">Anthropic (Sonnet-4, Opus-4)</span>
              </div>              
              <div className="flex items-center space-x-2">
                <img src={geminiLogo} alt="Gemini" className="h-6 w-6" />
                <span className="text-sm">Google (Gemini 2.5 Pro, Gemini 2.5 Flash)</span>
              </div>
            </div>
            <p className="text-sm text-[#6B7280] mt-2">More LLMs coming soon!</p>
          </div>

          <div>
            <h3 className="text-lg font-semibold pt-0 pb-4">Supported File Formats</h3>
            <div className="pb-0 md:pb-6">
              <ul className="list-disc pl-4 space-y-2">
                <li className="font-medium">CSV</li>
              </ul>
              <p className="text-sm text-[#6B7280]">With source and target columns</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 